<template>
    <div class="link-list" :class="[bemFacet]">
        <ul class="u-reset link-list--list">
            <li v-for="(entry, entryIdx) in entries" class="link-list--item">
                <span class="u-reset link-list--link" :class="[entry.multi_line ? ' link-list--link__top-align' : '']"
                        :title="entry.title || entry.label">
                    <a :href="entry.link" target="_blank" rel="noopener noreferrer"
                            class="link-list--icon">
                        <cmp-icon :symbol="entry.icon" size="small" class="link-list--icon-inner"></cmp-icon>
                    </a>
                    <span class="link-list--text">
                        <a :href="entry.link" target="_blank" rel="noopener noreferrer"
                                class="u-reset link-list--text-inner" v-html="entry.label"></a>
                        <span class="link-list--additional-content"
                                v-if="entry.additional_content"
                                v-html="entry.additional_content">
                        </span>
                    </span>
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';


    export default {
        mixins: [
            bemMixin('link-list'),
        ],
        props: {
            entries: {
                type: Array,
                default() {
                    return [];
                },
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?64ea885b